import { Component } from 'react';
import { AppConfig } from 'config';
import {
	Stack,
	Box,
	Heading,
	Flex,
	Text
} from '@chakra-ui/react';
import { connect, Dispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { UserSelectors } from 'reducers/User/selectors';
import { UserActions } from 'reducers/User/actions';
import { RouterProps, withRouter } from "utils/route";
import { generateSEOTitle, generateSEOLink } from 'utils/seo';
import { WaitlistCard, Logo, ContentInfoCard, SEOHelmet, InfiniteCarousel } from 'components';
import { UserModel } from 'models';
import { NavigationService } from 'services';
import { AppConstants } from '../../constants';
import { ApplicationState } from 'reducers/types';
import marketplaceImage from '../../assets/images/marketplace.webp';
import portfolioManagementImage from '../../assets/images/portfolio-management.png';
import appraisalImage from '../../assets/images/appraisal.png';
import stockChartImage from '../../assets/images/stock-chart.png';

interface JoinWaitlistViewProps extends RouterProps {
	user: UserModel;
	userWaitlistActionLoading: boolean;
	joinUserWaitlist: (email: string) => void;
}

class JoinWaitlist extends Component<JoinWaitlistViewProps, {}> {
	renderHomeInfoBlocks() {
		const content = [
			{ imageUrl: appraisalImage, header: 'Realtime Price Valuations', content: 'We harness the power of AI to provide real-time market valuations, comprehensive analysis, and detailed sales history.' },
			{ imageUrl: portfolioManagementImage, header: 'Portfolio Management', content: 'Traditional inventory management systems can be a headache. Our advanced technology handles everything seamlessly for you.' },
			{ imageUrl: marketplaceImage, header: 'Dedicated Marketplace', content: 'Our Trading Floor utilizes our proprietary valuation engine and provides a seamless overview of the best market deals.' },
			{ imageUrl: stockChartImage, header: 'Market Indexes', content: 'Our proprietary market indexes allow you to track the performance of the overall art market as well as markets of individual artists and mediums.' }

		];

		const carouselContent = content.map((infoContent, index) => (
			<ContentInfoCard
				key={`homePage_infoBlock_${index}`}
				header={infoContent.header}
				content={infoContent.content}
				imageUrl={infoContent.imageUrl}
			/>
		));

		return (
			<Box
				marginTop={8}
				marginBottom={8}
				paddingTop={5}
				paddingBottom={5}
				width={{ base: "100vw", md: "100%" }}
				position="relative"
			>
				<InfiniteCarousel
					content={carouselContent}
					speed={20}
					itemGap={16}
					pauseOnHover={true}
					enableEdgeFade={true}
				/>
			</Box>
		);
	}

	render() {
		const { joinUserWaitlist, userWaitlistActionLoading } = this.props;
		return (
			<>
				<SEOHelmet
					title={generateSEOTitle('Waitlist')}
					description={`Join our waitlist into the next generation of art collecting.`}
					link={generateSEOLink(NavigationService.getWaitlistPath())}
				/>
				<Box maxWidth={`${AppConstants.GRIDPAGE_WIDTH}px`} paddingTop={['80px', '100px', '100px']} justifySelf="center" minWidth={['100%', `${AppConstants.GRIDPAGE_WIDTH}px`]}>
					<Flex direction={'column'} alignItems={'center'}>
						<Logo height={'120px'} width={'120px'} />
						<Stack marginTop={4} gap={4}>
							<Heading fontSize={{ base: '2xl', md: '4xl' }}>Join our waitlist into the next generation of art collecting</Heading>
							<Text fontSize={{ base: 'lg', md: 'xl' }}>{AppConfig.APP_NAME} is currently on an invite-only mode. Sign up to get early access</Text>
						</Stack>
						{this.renderHomeInfoBlocks()}
						<WaitlistCard onButtonClick={joinUserWaitlist} buttonLoading={userWaitlistActionLoading} />
					</Flex>
				</Box>
			</>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		user: UserSelectors.getUser(state),
		userWaitlistActionLoading: UserSelectors.getUserWaitlistActionLoading(state),
	};
}

function mapDispatchToProps(dispatch: Dispatch<ApplicationState>) {
	return bindActionCreators(
		{
			joinUserWaitlist: (email: string) => UserActions.joinUserWaitlist(email)
		},
		dispatch
	);
}

export const JoinWaitlistView = connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(JoinWaitlist));
